import { h } from 'preact';
import { getEarningsEstimatesBySecurity } from '@os/cloudquote';
import { Text } from 'preact-i18n';
import createDataTable, { tableUtils } from '../cloudquote-data-table';

const INTL_NS = 'analysts-panel.growthEstimates';

function pick(data, key) {
	return String(data.rows[0][data.columns.indexOf(key)]);
}

export const GrowthEstimatesDataTable = createDataTable({
	headers: [
		<Text id={`${INTL_NS}.growthEstimates`} />,
		<Text id={`${INTL_NS}.percentGrowth`} />
	],
	cells: [
		'Label',
		tableUtils.formatField('Growth Estimate', value => value && (value !== 'null' || value === 0) ? `${value}%` : '-')
	],
	sort: function normalizeEarningsEstimatesData(data) {
		if (!data || !data.rows || !data.rows.length) { return data; }
		return {
			columns: [ 'Label', 'Growth Estimate' ],
			// this table will have 5 rows
			rows: [
				[
					<Text id={`${INTL_NS}.currentQtr`} />,
					pick(data, 'curQuarterGrowthEstimateVsYearPriorEPS')
				],
				[
					<Text id={`${INTL_NS}.nextQtr`} />,
					pick(data, 'nextQuarterGrowthEstimateVsYearPriorEPS')
				],
				[
					<Text id={`${INTL_NS}.currentYear`} />,
					pick(data, 'curYearGrowthEstimateVsPrevYearEPS')
				],
				[
					<Text id={`${INTL_NS}.nextYear`} />,
					pick(data, 'nextYearGrowthEstimateVsCurYearEstimate')
				],
				[
					<Text id={`${INTL_NS}.nextFiveYears`} />,
					pick(data, 'longTermGrowthMeanEstimate')
				]
			]
		};
	},
	apiMethod: getEarningsEstimatesBySecurity
});

